<template>
  <div>
    <o-table :title="$t('core.ip_addresses')" url="/api/system/ipaddresses" ref="tableList">
      <template slot="filter">
        <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
          <o-filter-text :title="$t('core.ip_address')" column="ip_address"></o-filter-text>
          <o-filter-text :title="$t('sandoz.comment')" column="comment"></o-filter-text>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="ip_address">{{$t('core.ip_address')}}</o-table-header>
        <o-table-header column="comment">{{$t('sandoz.comment')}}</o-table-header>
        <o-table-header column="created_at">{{$t('core.created_at')}}</o-table-header>
      </template>
      <template slot="head-controls" slot-scope="props">
        <th class="text-right">
          <router-link :to="{ path: $route.path + '/new'}" class="btn btn-primary">
            {{$t('core.new')}}
          </router-link>
          <button class="btn btn-primary" @click="openNewTextModal">{{ $t('core.new_from_text') }}</button>
        </th>
      </template>
      <template slot="body" slot-scope="props">
        <td>{{ props.item.ip_address }}</td>
        <td>{{ props.item.comment }}</td>
        <td>{{ props.item.created_at | formatDatetime }}</td>
      </template>
      <template slot="body-controls" slot-scope="props">
        <td class="text-right">
          <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
            <o-delete method="delete" :url="$refs.tableList.deleteUrl() + '/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
            <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
              <fa icon="pencil-alt"/>
            </router-link>
          </div>
        </td>
      </template>
    </o-table>
    <b-modal ref="newFromText" :title="$t('core.new_from_text')" :ok-title="$t('sandoz.continue')" @ok="addIpaddressData" size="lg">
      <b-row>
        <b-col>
          <o-textarea v-model="textIpData" rows="10"></o-textarea>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    textIpData: null,
    extractedIPs: []
  }),
  methods: {
    openNewTextModal () {
      this.$refs.newFromText.show()
    },
    addIpaddressData() {
      const ipRegex = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g;
      const matches = this.textIpData.match(ipRegex);
      if (matches) {
        this.extractedIPs = matches;
      } else {
        this.extractedIPs = [];
      }

      axios.post('/api/system/ipaddresses/new-from-text', {
        extractedIP: this.extractedIPs,
      }).then((response) => {
        this.textIpData = null
        this.$notify({
          title: this.$i18n.t('core.saved_text'),
          text: this.$i18n.t('core.saved_text'),
        })
      }).catch((error) => {
        this.$notify({
          title: this.$i18n.t('core.error'),
          text: this.$i18n.t('core.error_text', {error: error}),
          type: 'error'
        })
      })
    }
  }
}
</script>
